import { render, staticRenderFns } from "./NewShipping.vue?vue&type=template&id=d8c71be8"
import script from "./NewShipping.vue?vue&type=script&lang=js"
export * from "./NewShipping.vue?vue&type=script&lang=js"
import style0 from "./NewShipping.vue?vue&type=style&index=0&id=d8c71be8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports